import { useState } from 'react';
import { Attendee } from '../components/ZplPrinter';
import { PrintConfig, DEFAULT_PRINT_CONFIG } from '../components/PrintSettings';

export function usePrinting() {
  const [printingEnabled, setPrintingEnabled] = useState(false);
  const [printerReady, setPrinterReady] = useState(false);
  const [pendingPrintAttendee, setPendingPrintAttendee] = useState<Attendee | null>(null);
  const [zplFeedback, setZplFeedback] = useState<string | null>(null);
  const [printConfig, setPrintConfig] = useState<PrintConfig>(DEFAULT_PRINT_CONFIG);

  const handleTogglePrinting = () => {
    if (!printingEnabled) {
      const confirmed = window.confirm(
        'Zebra Browser Print must be initialized and the default printer must be configured.'
      );
      if (confirmed) {
        setPrintingEnabled(true);
        setPendingPrintAttendee({}); // Print test label
      }
    } else {
      setPrintingEnabled(false);
    }
  };

  const handlePrinterReady = (ready: boolean) => setPrinterReady(ready);
  const handlePrintResult = (result: { success: boolean; message: string }) => setZplFeedback(result.message);

  return {
    printingEnabled,
    printerReady,
    pendingPrintAttendee,
    setPendingPrintAttendee,
    zplFeedback,
    printConfig,
    setPrintConfig,
    handleTogglePrinting,
    handlePrinterReady,
    handlePrintResult,
  };
}
